import { ConversationStatus } from 'generated-graphql/types';
import { ClosingMethod } from 'services/campaign/types';
import { progressScreeningStatusMapper } from 'modules/conversations/utils';
import { ScreeningStatusChip } from 'modules/conversations/components/ScreeningStatusChip';

export const getConversationStatusOptions = (
  conversationStatusAvailableOptions: ConversationStatus[],
  closingMethod: ClosingMethod
) => {
  const progressedStatus = progressScreeningStatusMapper(closingMethod);

  return [
    {
      label: <ScreeningStatusChip status={progressedStatus} />,
      value: progressedStatus,
      disabled: !conversationStatusAvailableOptions.includes(progressedStatus)
    },
    {
      label: (
        <ScreeningStatusChip status={ConversationStatus.CompletedRejected} />
      ),
      value: ConversationStatus.CompletedRejected,
      disabled: !conversationStatusAvailableOptions.includes(
        ConversationStatus.CompletedRejected
      )
    },
    {
      label: (
        <ScreeningStatusChip
          status={ConversationStatus.CompletedNotInterested}
        />
      ),
      value: ConversationStatus.CompletedNotInterested,
      disabled: !conversationStatusAvailableOptions.includes(
        ConversationStatus.CompletedNotInterested
      )
    },
    {
      label: <ScreeningStatusChip status={ConversationStatus.Completed} />,
      value: ConversationStatus.Completed,
      disabled: !conversationStatusAvailableOptions.includes(
        ConversationStatus.Completed
      )
    },
    {
      label: <ScreeningStatusChip status={ConversationStatus.OptedOut} />,
      value: ConversationStatus.OptedOut,
      disabled: !conversationStatusAvailableOptions.includes(
        ConversationStatus.OptedOut
      )
    }
  ];
};
